// context.js
import { createContext } from 'react';

export const ContextInventaire = createContext('');